import rentalHtml from './rental.component.html';
import { Polish } from 'flatpickr/dist/l10n/pl.js';

class RentalController {
    constructor($scope, $sce, $timeout, RentalService) {
        'ngInject';

        this.$scope = $scope;
        this.$sce = $sce;
        this.$timeout = $timeout;
        this.service = RentalService;

        //const tomorrow = new Date();
        //tomorrow.setDate(new Date().getDate() + 1);

        const today = new Date();
        today.setDate(new Date().getDate());

        this.rentalPeriodCalendar = null;
        this.rentalPeriod = null;
        this.openingHoursVisible = false;
        this.rentalPeriodCalendarConfig = {
            dateFormat: 'd.m.Y',
            locale: Polish,
            minDate: today,
            disable: [],
            onChange: function(selectedDates, dateStr, instance) {
                if (selectedDates.length === 0) {
                    return;
                }

                const lastSelectedDate = selectedDates[selectedDates.length - 1];
                if (lastSelectedDate.getDay() === 0) {
                    instance.clear();
                    RentalService.userData.rentalPeriodFrom = null;
                    RentalService.userData.rentalPeriodTo = null;
                    RentalService.price.price = 0;
                }
            },
            onClose: function(selectedDates, dateStr, instance) {
                if (selectedDates.length < 2) {
                    return;
                }

                let dateFrom = new Date(selectedDates[0]);
                let dateTo = new Date(selectedDates[1]);

                if (dateFrom.getDay() === 0 || dateTo.getDay() === 0) {
                    instance.clear();
                    RentalService.userData.rentalPeriodFrom = null;
                    RentalService.userData.rentalPeriodTo = null;
                    RentalService.price.price = 0;
                    return;
                }

                RentalService.userData.rentalPeriodFrom = dateFrom.getFullYear() + '-' + (dateFrom.getMonth() + 1) + '-' + dateFrom.getDate();
                RentalService.userData.rentalPeriodTo = dateTo.getFullYear() + '-' + (dateTo.getMonth() + 1) + '-' + dateTo.getDate();

                RentalService.calculatePrice();
            }
        };
        this.rentalPeriodCalendarConfigChangeDisableDates = false;
    }

    $onInit() {
        this.syncRadioGroups();

        if (!this.service.loaded && !this.service.loading) {
            this.service.load().then(function(response) {
                this.syncRadioGroups();

                this.$scope.$watch(
                    () => this.rentalPeriodCalendar,
                    () => {
                        if (this.rentalPeriodCalendarConfigChangeDisableDates === false) {
                            this.rentalPeriodCalendarConfigChangeDisableDates = true;
                            this.rentalPeriodCalendar.set('disable', response.product.disableDates);
                        }
                    }
                );
            }.bind(this));
        }
    }

    rentalPeriodCalendarPostSetup(rentalPeriodCalendar) {
        this.rentalPeriodCalendar = rentalPeriodCalendar;
    }

    setShipment(shipment) {
        this.service.setShipment(shipment);

        this.syncRadioGroups();
    }

    setPayment(payment) {
        this.service.setPayment(payment);
        this.syncRadioGroups();
    }

    toggleOpeningHours($event) {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }

        this.openingHoursVisible = !this.openingHoursVisible;
    }

    syncRadioGroups() {
        this.$timeout(() => {
            document.querySelectorAll('.rental-form .shipment input[type="radio"]').forEach((input) => {
                input.name = 'rental_shipment';
            });

            document.querySelectorAll('.rental-form .payment input[type="radio"]').forEach((input) => {
                input.name = 'rental_payment';
            });
        });
    }

    submit() {
        this.service.submit().then(function() {
            this.service.step = 2;
        }.bind(this));
    }

    submitWithError() {
        this.service.showAllErrors = true;
    }
}

let rentalComponent = {
    bindings: {
        'productSlug': '<'
    },
    template: rentalHtml,
    controller: RentalController
};

export default rentalComponent;
